import reduceRight from 'lodash/reduceRight';
import reduce from 'lodash/reduce';

const SEC_IN_SEC  = 1;
const SEC_IN_MIN  = 60;
const MIN_IN_HOUR = 60;
const SEC_IN_HOUR = SEC_IN_MIN * MIN_IN_HOUR;
const MS_IN_SEC   = 1000;
const DELIM = ':';
const ZERO = 0;

const MULTIPLIERS = [ SEC_IN_HOUR, SEC_IN_MIN, SEC_IN_SEC ];
// const IDX_FOR_COMPACT_MODE = 1;

const ROUND_SCALE = 3;
const INTEGER_PART_LENGTH = 2;


export default function decode(num, compactMode) {
   num = num / MS_IN_SEC;
   // const multipliers = compactMode ? MULTIPLIERS.slice(IDX_FOR_COMPACT_MODE) : MULTIPLIERS;
   const res = reduce(MULTIPLIERS, (memo, multiplier) => {
      memo = memo ? `${memo}:` : '';
      memo += _pad(Math.floor(num / multiplier));
      num = num % multiplier;
      return memo;
   }, '');

   return compactMode ? res : `${res}.${_decimalPart(num)}`;
}

export function encode(str) {
   const times = str.split(DELIM);

   return reduceRight(MULTIPLIERS, (memo, multiplier) => {
      return memo + multiplier * (+times.pop() || ZERO);
   }, ZERO);
}

function _pad(num) {
   // eslint-disable-next-line no-magic-numbers
   return num > 9 ? `${num}` : `0${num}`;
}

function _decimalPart(num) {
   return (num % SEC_IN_SEC).toFixed(ROUND_SCALE).substring(INTEGER_PART_LENGTH);
}
